import { styled } from '@mui/material/styles';
import { COLOR } from '@src/styles/color';
import { BREAKPOINTS, MOBILE_BREAKPOINT } from '@src/styles/config';

export const StyledRewardTasks = styled('div')`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media (max-width: ${BREAKPOINTS.SMD}px) {
    .title-section-text {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const StyledTask = styled('div')`
  padding: 16px 28px;
  border-radius: 12px;
  border: 1px solid ${COLOR.errorHover};
  display: flex;
  gap: 16px;
  align-items: center;

  .countdown-text-mobile {
    display: none;
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    padding: 16px;
    .countdown-text-mobile {
      display: block;
    }
    .countdown-text-desktop {
      display: none;
    }
    .tootlip-info-container {
      display: none;
    }
  }
`;

export const StyledTaskContent = styled('div')`
  display: flex;
  justify-content: space-between;
  flex: 1;
  align-items: center;

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
    .info-title {
      font-size: 14px;
    }
  }
`;

export const StyledTaskInfo = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .info-text {
      display: none;
    }
  }
`;

export const StyledTaskCredits = styled('div')`
  display: flex;
  align-items: center;
  gap: 4px;
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    .reward-credits-text {
      width: max-content !important;
      text-align: left !important;
    }
  }
`;

export const StyledTaskButton = styled('div')`
  display: flex;
  align-items: flex-end;
  flex-direction: column;
  margin-left: 20px;
  gap: 4px;
  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    margin-left: 0px;
  }
`;
